module.exports = __webpack_public_path__ + "static/img/9.2c346c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/4/zh/9.png
// module id = OrkK
// module chunks = 0